import { useContext, useEffect, createContext, useState } from 'react';
import * as localStorage from '@/services/localStorage';
import { LocalStorageItemKeys, ComponentWithChildrenType, SidebarStatusType } from '@/types';

const defaultState = { isSidebarOpen: true, toggleSidebarStatus: () => {} };
const SidebarStatusContext = createContext(defaultState);
const isSidebarOpenValue = 'isSidebarOpen';

export function SidebarStatusProvider({ children }: ComponentWithChildrenType): JSX.Element {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  useEffect(() => {
    const previousValue = localStorage.getLocalStorage(LocalStorageItemKeys.SIDEBAR_STATUS);
    setIsSidebarOpen(() => previousValue === isSidebarOpenValue);
  }, []);

  useEffect(() => {
    const sidebarNewStatus = isSidebarOpen ? isSidebarOpenValue : '';
    localStorage.setLocalStorage(LocalStorageItemKeys.SIDEBAR_STATUS, sidebarNewStatus);
  }, [isSidebarOpen]);

  const toggleSidebarStatus = (): void => {
    setIsSidebarOpen((prev) => !prev);
  };

  return (
    <SidebarStatusContext.Provider value={{ isSidebarOpen, toggleSidebarStatus }}>
      {children}
    </SidebarStatusContext.Provider>
  );
}

export default function useSidebarStatus(): SidebarStatusType {
  return useContext(SidebarStatusContext);
}
